<template>
  <template v-for="(spf, index) in processedRecords" :key="index">
    <span class="block mb-3">This record is valid for <duration :seconds="spf.record.ttl" />.</span>
    <spf-record-component :domain="domain" :terms="spf.parsedSpf" />
  </template>
  <Alert type="warning" v-if="!processedRecords.length">
    <span><span class="font-semibold">{{ domain }}</span> does not have any {{recordType.upper}} records.</span>
  </Alert>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { getRecordType } from '@/common/recordTypes';
import Alert from '@/components/micro/AlertComponent.vue';
import Duration from '@/components/micro/DurationComponent.vue';
import SpfRecordComponent from '@/components/records/SpfRecord.vue';
import { QueryResult, RecordInfo, TXT } from '@/model/Api';

const props = defineProps({
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
  domain: {
    type: String,
    required: true,
  },
});

type SpfRecord = {
  record: TXT;
} & RecordInfo

const recordType = getRecordType('SPF');
const processedRecords = computed(() => props.records.response.answer.filter((item): item is SpfRecord => item.record.recordType === 'TXT' && item.parsedSpf !== undefined));
</script>
